export const MIN_DRAWDOWN_AMOUNT = 100;
